import React, { useState, useEffect, useRef, useCallback } from "react";
import Dropdown from "../../../Components/CustomDropdown/customdropdown";
import ConfirmContinueButton from "../../../Components/ContinueButton/continue-button";
import ConfirmResetButton from "../../../Components/ContinueButton/reset-button";
import { updateFormData } from "../../../Redux/store/onboardingFormSlice";
import { useDispatch, useSelector } from "react-redux";

const CashAccount = ({ setCurrentStep, applicationType }) => {
  const formData = useSelector((state) => state.form.formData);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [accountCount, setAccountCount] = useState(1);
  const currenci22es = [
    "AUD (Australia)",
    "EUR (Europe)",
    "GBP (British)",
    "USD (USA)",
    "CAD (Canada)",
    "JPY (Japan)",
    "CHF (Switzerland)",
  ];
  const currencies = [
    {
      value: 1,
      label: "AUD (Australia)",
    },
    {
      value: 2,
      label: "EUR (Europe)",
    },
    {
      value: 3,
      label: "GBP (British)",
    },
    {
      value: 4,
      label: "USD (USA)",
    },
    {
      value: 5,
      label: "CAD (Canada)",
    },
    {
      value: 6,
      label: "JPY (Japan)",
    },
    {
      value: 7,
      label: "CHF (Switzerland)",
    },
  ];
  const [accounts, setAccounts] = useState(
    Array.from({ length: 1 }, (_, i) => currencies[i] || "")
  );

  const handleAccountChange = (index, value) => {
    const newAccounts = [...accounts];
    newAccounts[index] = value;
    setAccounts(newAccounts);
  };
  const increaseCount = () => {
    if (accountCount < currencies.length) {
      setAccountCount(accountCount + 1);
      setAccounts([...accounts, currencies[accountCount] || ""]);
    }
  };

  const decreaseCount = () => {
    if (accountCount > 1) {
      setAccountCount(accountCount - 1);
      setAccounts(accounts.slice(0, -1));
    }
  };
  const handleContinue = () => {
    handlesave();
    if (applicationType == 1) {
      setCurrentStep(6);
    }
    if (applicationType == 2) {
      setCurrentStep(5);
    }
  };
  const handleReset = () => {
    setCurrentStep(1);
  };
  const handleBack = () => {
    if (applicationType == 1) {
      setCurrentStep(4);
    }
    if (applicationType == 2) {
      setCurrentStep(3);
    }
  };
  const handlesave = () => {
    dispatch(updateFormData({ field: "userAccounts", value: accounts }));
  };
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow  overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2 mb-2">
              <img src="/money-2.svg" alt="Money Icon" className="h-6 w-6" />
              <h1 className="text-xl font-medium">Cash Account Information</h1>
            </div>
            <ul className="ml-2 text-xs font-medium">
              <li>
                Every Cash Account has a seeding amount of $10,000 and a monthly
                maintenance fee associated with it.
              </li>
              <li className="text-[#FF5050]">
                If you need to adjust any information from the previous section,
                please click on the “Reset Application” button
              </li>
            </ul>
          </div>

          <div className="px-4 mt-4 flex items-center space-x-0 text-black font-medium ">
            <span className="text-sm mr-4">No. Of Cash Account</span>
            <button
              onClick={decreaseCount}
              className="border-2 border-gray-300 px-3 py-1  rounded-tl-xl rounded-bl-xl hover:bg-gray-200"
            >
              −
            </button>
            <span className="px-4 py-1  border-t-2 border-b-2 border-gray-300">
              {accountCount}
            </span>
            <button
              onClick={increaseCount}
              className="px-3 py-1  hover:bg-gray-200  border-2 border-gray-300 rounded-tr-xl rounded-br-xl"
            >
              +
            </button>
          </div>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {Array.from({ length: accountCount }).map((_, index) => (
              <div key={index} className="px-4 py-2">
                <Dropdown
                  label={<>Account {String(index + 1).padStart(2, "0")}</>}
                  options={currencies}
                  preselectedValue={accounts[index]}
                  onSelect={(value) => handleAccountChange(index, value)}
                  // preselectedValue={preselectedAccountType}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <footer className="bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
        <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 relative">
          <ConfirmResetButton onConfirm={handleReset} onBack={handleBack} />
        </div>

        <div className="flex flex-col md:flex-row mt-2 md:mt-0 items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
          <div className="relative w-full md:w-auto flex justify-center md:justify-end">
            <button className="flex w-full md:w-auto items-center justify-center space-x-2 text-white border-white border-2 font-medium py-2 px-4 rounded-full text-sm">
              <span>Save as Draft</span>
            </button>
          </div>
          <ConfirmContinueButton
            onContinue={handleContinue}
            buttonText="Continue"
            confirmTitle="Save Section"
            confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
          />
        </div>
      </footer>
    </div>
  );
};

export default CashAccount;
